import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import AOS from 'aos'
import Text from '../../../../elements/Typo/Text'
import MetricRow from './_components/MetricRow'
import { ErrorResponse } from '../../../../store/api/apiTypes'
import { useDeepDiveApi } from '../../../../store/api/hooks/deepDiveApiHook'
import { useParams } from 'react-router-dom'
import Loader from '../../../../components/loader'

const headerClass = ' flex justify-center  items-center text-[0.52rem]  text-gray-400  text-center leading-3  '

interface Props {
    selectedGroup: string | null
    selectedKPI: string | null
    selectedDateRange: any[]
    selectedOptionConfig?: string | null
    toDownloadAsReport?: boolean
    reportError?: (x: boolean) => void
}
const AverageMetricDeepDive: React.FC<Props> = ({ selectedGroup, selectedKPI, selectedDateRange, selectedOptionConfig, toDownloadAsReport = false, reportError }) => {
    const { t } = useTranslation()
    const [apiData, setApiData] = useState<any>(null)
    const [avgMetricData, setAvgMetricData] = useState<any>([])
    const params = useParams()
    const [loading, setLoading] = useState<boolean>(true)

    const { getAvgMetric } = useDeepDiveApi()

    useEffect(() => {
        if (selectedGroup) {
            const postData: any = {
                literal: params.exptLiteral,
                group_name: selectedGroup,
                kpiname: selectedKPI,
            }

            if (selectedOptionConfig != undefined) {
                postData.methodology = selectedOptionConfig
            }

            if (selectedDateRange.length == 2) {
                postData.measurement_start_date = selectedDateRange[0]
                postData.measurement_end_date = selectedDateRange[1]
                postData.is_slice_and_dice = true
            } else {
                postData.measurement_start_date = null
                postData.measurement_end_date = null
                postData.is_slice_and_dice = false
            }

            getAvgMetric(
                postData,
                (data: any) => {
                    const values = data?.data
                    setApiData(values)
                },
                (error: ErrorResponse<[]>) => {
                    console.log(error)
                    if (reportError) {
                        reportError(true)
                    }
                },
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroup, selectedKPI, selectedOptionConfig, selectedDateRange])
    useEffect(() => {
        if (selectedKPI && apiData) {
            const newFilter = apiData?.[`${selectedKPI}`]

            const filteredData =
                newFilter &&
                Object.entries(newFilter)?.map(([key, value]) => ({
                    title: key == 'Synthetic Control' && selectedKPI == 'Total Distribution' ? 'Counterfactual' : key,
                    ...(typeof value === 'object' && value !== null ? value : {}),
                }))

            if (filteredData) {
                setAvgMetricData(filteredData)
                setLoading(false)
            }
        }
    }, [selectedKPI, apiData])
    useEffect(() => {
        const params: any = {}

        if (toDownloadAsReport) {
            params['disable'] = true // Animation disabled
        } else {
            params['once'] = false // Animation occurs every time you scroll to the element
        }

        AOS.init(params)
        AOS.refresh()
    }, [])

    return (
        <div className=" bg-base-100 rounded-[0.45rem] shadow-1" data-aos="zoom-in" data-aos-delay="100">
            <div className=" px-3 py-3 rounded-[0.45rem]  shadow-1 ">
                <div className="flex place-content-between h-fit mb-4">
                    <div className="font-semibold">
                        <Text size="md" className="block">
                            {t('Average metric')}
                        </Text>
                        <Text size="xs" className="text-gray-500 text-[0.52rem]">
                            {selectedKPI == 'Total Distribution' ? t('(Measurement/Analysis Period)') : t('(After Intervention)')}
                        </Text>
                    </div>
                </div>
                {loading ? (
                    <Loader />
                ) : (
                    <div className=" border-r-0 md:border-r ">
                        <div className="grid grid-cols-12 gap-4 text-sm font-semibold  pb-2">
                            <div className="col-span-3 text-[0.52rem] text-gray-500 ">
                                <div className="grid grid-cols-2">
                                    <div className={headerClass + '  !text-start !justify-start'}>{t('Group Names')}</div>
                                    <div className={headerClass + '  '}>{t('Action Taken')}</div>
                                </div>
                            </div>
                            <div className={headerClass + '  '}>{t('Mean')}</div>
                            <div className={headerClass + '  '}>{t('Min')}</div>
                            <div className={headerClass + '  '}>{t('Max')}</div>
                            <div className={headerClass + '  '}>{t('Uplift v/s Control')}</div>
                            <div className={headerClass + '   '}>{t('Uplift v/s Test')}</div>
                            <div className={headerClass + '  col-span-2'}>{t('Number of Samples in Design')}</div>
                            <div className={headerClass + '   col-span-2'}>{t('Number of Samples in Measurement')}</div>
                        </div>
                        {avgMetricData.map((metric: any, index: number) => (
                            <MetricRow key={`${metric.title}-${index}`} {...metric} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}
export default AverageMetricDeepDive
